import React, { memo } from "react"
import { AppNode } from "@features/builder/graph/types"
import NodeContainer from "@features/builder/graph/nodes/NodeContainer"

export const LowDetailNode = memo((node: AppNode) => {
  return (
    <NodeContainer node={node}>
      <div className={`graph-node-container graph-node-lod graph-node-lod-${node.type}`}>
        <div className="graph-node-label">{node.data.label}</div>
      </div>
    </NodeContainer>
  )
})

LowDetailNode.displayName = "LowDetailNode"
